/**
 * @author Sarthak Sharma.
 * @since 31-01-2024.
 * @type {string} PROFILE action types.
 */

export const SET_LOADING = '[RECRUITER_PROFILE] SET_LOADING';
export const SET_PROFILE_DATA = '[RECRUITER_PROFILE] SET_PROFILE_DATA';
export const SET_PROFILE_METADATA = '[RECRUITER_PROFILE] SET_PROFILE_METADATA';

export const SET_RECEIVED_CONTACT_LIST = '[RECRUITER_PROFILE] SET_RECEIVED_CONTACT_LIST';
export const SET_ASKED_FOR_CONTACT_LIST = '[RECRUITER_PROFILE] SET_ASKED_FOR_CONTACT_LIST';

